import { requestGet } from '../request';
import apiPath from './apiPath';
const api = {
  GetAllGeneral(type) {
    return requestGet(apiPath.GENERALDATA.path, { type: type });
  }
};

export default api;
